/* eslint no-underscore-dangle: "off" */
import React from "react";
import ReactDOM from "react-dom";
// import { browserHistory, } from 'react-router'
import { syncHistoryWithStore } from "react-router-redux";
import createStore from "./store/createStore";
import "./styles/main.less";
import modules from "./modules";

import { createHistory, useBasename } from "history";

const browserHistory = useBasename(createHistory)({
  basename: __BASE_NAME__
});

const actions = {
  dashboard: modules.actions.dashboard,
  social: modules.actions.social
};

// Store Initialization
// ------------------------------------
const store = createStore(window.__INITIAL_STATE__);

// Get reference data
store.dispatch(actions.social.getProfileBrands());

const syncedHistory = syncHistoryWithStore(browserHistory, store);

// Render Setup
// ------------------------------------
const MOUNT_NODE = document.getElementById("root");

let render = () => {
  const App = require("./app").default;
  const routes = require("./routes/index").default(store);

  ReactDOM.render(
    <App store={store} routes={routes} history={syncedHistory} />,
    MOUNT_NODE
  );
};

// Development Tools
// ------------------------------------
if (__DEV__) {
  if (module.hot) {
    const renderApp = render;
    const renderError = error => {
      const RedBox = require("redbox-react").default;

      ReactDOM.render(<RedBox error={error} />, MOUNT_NODE);
    };

    render = () => {
      try {
        renderApp();
      } catch (e) {
        console.error(e);
        renderError(e);
      }
    };

    // Setup hot module replacement
    module.hot.accept(["./app", "./routes/index"], () =>
      setImmediate(() => {
        ReactDOM.unmountComponentAtNode(MOUNT_NODE);
        render();
      })
    );
  }
}

// Let's Go!
// ------------------------------------
if (!__TEST__) render();



// WEBPACK FOOTER //
// ./src/main.jsx